import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImageOptimizerDirective } from 'lazy-load-image';
import { BaseButtons, ButtonsLoaderModule } from 'buttons-loader';
import { AuthorizationModule } from 'authorization';
import { AccordionModule } from 'primeng/accordion';
import { ProductionModeService } from 'src/domains/share/app/service/production-mode/production-mode.service';
import { FaqRoute } from 'src/domains/site-managment/app/feature/faq/faq.route';
import { TermRoute } from 'src/domains/site-managment/app/feature/term/term.route';
@UntilDestroy()
@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  imports: [
    AuthorizationModule,
    AccordionModule,
    ButtonsLoaderModule,
    ImageOptimizerDirective,
  ],
})
export class AppFooterComponent implements AfterViewInit {
  app_text: string = `همسازسامان یک پلتفرم نوآورانه در حوزه سرمایه‌گذاری خرد در بازار مسکن است که فرصتی بی‌نظیر برای مشارکت در
            پروژه‌های
            ساختمانی با مبالغ کم فراهم می‌کند. این پلتفرم با بهره‌گیری از مدل سرمایه‌گذاری جمعی امکان سرمایه‌گذاری خرد به صورت توکنی از پروژه‌های مختلف را برای عموم مردم فراهم کرده است. به این ترتیب، افراد با هر میزان بودجه می‌توانند در رونق
            بازار مسکن
            سهیم شده و از سودهای بالقوه این بازار بهره‌مند شوند. همسازسامان با ارائه گزارش‌های شفاف، محیطی امن و مطمئن
            برای
            سرمایه‌گذاری فراهم کرده است.`;
  isExpanded: boolean = false;
  showMoreBtn: BaseButtons<any>;
  showLessBtn: BaseButtons<any>;
  footer__nav: HTMLElement;
  footer_responsive: HTMLElement;
  mode = ProductionModeService.whereAmI();
  faqs = FaqRoute.map.mainpage.view_faqs;
  terms = TermRoute.map.mainpage.terms_and_conditions;

  constructor(
    private render2: Renderer2,
    private breakPointObserver: BreakpointObserver,
  ) {
    this.showMoreBtn = {
      label: 'بیشتر',
      class: 'border-0 bg-transparent primary_6 show-more-btn',
      postfixIcon: 'isax icon-arrow-left',
      action: () => {
        this.toggleText();
      },
    };

    this.showLessBtn = {
      label: 'کمتر',
      class: 'border-0 bg-transparent primary_6 show-less-btn',
      postfixIcon: 'isax icon-arrow-right-1',
      action: () => {
        this.toggleText();
      },
    };
  }

  ngAfterViewInit(): void {
    this.breakPointObserver
      .observe(['(max-width:992px)'])
      .pipe(untilDestroyed(this))
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.footer__nav = this.render2.selectRootElement(
            '.header__navbar',
            true,
          );

          this.footer_responsive = this.render2.selectRootElement(
            '.footer_responsive_padding',
            true,
          );

          this.footer_responsive.style.paddingBottom =
            this.footer__nav.offsetHeight + 20 + 'px';
        }
      });
  }

  get displayText(): string {
    return this.isExpanded
      ? this.app_text
      : this.app_text.slice(0, 200) + '...';
  }

  toggleText() {
    this.isExpanded = !this.isExpanded;
  }
}
